import _extends from "@babel/runtime/helpers/extends";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Chip as MuiChip, createStyles, makeStyles } from '@material-ui/core';
import * as React from 'react';
import makeClass from 'classnames';
import { Cancel, Done } from '@material-ui/icons';
var useStyles = makeStyles(function (theme) {
  return createStyles({
    root: function root(props) {
      return {
        textTransform: props.uppercase ? 'uppercase' : 'none',
        letterSpacing: '1.1px'
      };
    },
    defaultOutlined: {
      color: theme.palette.getContrastText(theme.palette.background.default)
    },
    success: {
      backgroundColor: theme.palette.success.main,
      color: theme.palette.getContrastText(theme.palette.success.main)
    },
    info: {
      backgroundColor: theme.palette.info.main,
      color: theme.palette.getContrastText(theme.palette.info.main)
    },
    warning: {
      backgroundColor: theme.palette.warning.main,
      color: theme.palette.getContrastText(theme.palette.warning.main)
    },
    error: {
      backgroundColor: theme.palette.error.main,
      color: theme.palette.getContrastText(theme.palette.error.main)
    }
  });
});

var Chip = function Chip(_ref) {
  var _makeClass;

  var dsOnDelete = _ref.dsOnDelete,
      e2e = _ref.e2e,
      state = _ref.state,
      variant = _ref.variant,
      label = _ref.label,
      dismissible = _ref.dismissible,
      completable = _ref.completable,
      _ref$uppercase = _ref.uppercase,
      uppercase = _ref$uppercase === void 0 ? true : _ref$uppercase;
  var classes = useStyles({
    uppercase: uppercase
  });
  return /*#__PURE__*/React.createElement(MuiChip, _extends({
    className: makeClass((_makeClass = {}, _defineProperty(_makeClass, classes.root, true), _defineProperty(_makeClass, classes.defaultOutlined, state === 'default' && variant === 'outlined'), _defineProperty(_makeClass, classes.success, state === 'success'), _defineProperty(_makeClass, classes.info, state === 'info'), _defineProperty(_makeClass, classes.warning, state === 'warning'), _defineProperty(_makeClass, classes.error, state === 'error'), _makeClass))
  }, e2e && {
    'data-e2e': e2e
  }, {
    size: "small",
    label: label,
    variant: variant,
    onDelete: dismissible || completable ? dsOnDelete : undefined,
    deleteIcon: completable ? /*#__PURE__*/React.createElement(Done, e2e && {
      'data-e2e': "".concat(e2e, "-complete")
    }) : dismissible ? /*#__PURE__*/React.createElement(Cancel, e2e && {
      'data-e2e': "".concat(e2e, "-dismiss")
    }) : undefined
  }, (state === 'primary' || state === 'secondary') && {
    color: state
  }));
};

export default Chip;

try {
  Chip.__docgenInfo = {
    description: '',
    displayName: 'Chip',
    methods: [],
    props: {
      dsOnDelete: {
        defaultValue: null,
        description: '',
        name: 'dsOnDelete',
        required: false,
        type: {
          name: '(event: any) => void'
        }
      },
      e2e: {
        defaultValue: null,
        description: '',
        name: 'e2e',
        required: false,
        type: {
          name: 'string'
        }
      },
      state: {
        defaultValue: null,
        description: '',
        name: 'state',
        required: true,
        type: {
          name: 'enum',
          raw: '"default" | "success" | "info" | "warning" | "error" | "primary" | "secondary"',
          value: [{
            value: '"default"'
          }, {
            value: '"success"'
          }, {
            value: '"info"'
          }, {
            value: '"warning"'
          }, {
            value: '"error"'
          }, {
            value: '"primary"'
          }, {
            value: '"secondary"'
          }]
        }
      },
      dismissible: {
        defaultValue: null,
        description: '',
        name: 'dismissible',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      completable: {
        defaultValue: null,
        description: '',
        name: 'completable',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      uppercase: {
        defaultValue: {
          value: true
        },
        description: '',
        name: 'uppercase',
        required: false,
        type: {
          name: 'boolean'
        }
      },
      variant: {
        defaultValue: null,
        description: 'The variant to use.',
        name: 'variant',
        required: false,
        type: {
          name: 'enum',
          raw: '"outlined" | "default"',
          value: [{
            value: '"outlined"'
          }, {
            value: '"default"'
          }]
        }
      },
      label: {
        defaultValue: null,
        description: 'The content of the label.',
        name: 'label',
        required: false,
        type: {
          name: 'ReactNode'
        }
      }
    }
  };
} catch (e) {}
//# sourceMappingURL=index.js.map